<template>
  <div class="i-stats-bar">
    <div class="container-wide">
      <div class="stats-bar__grid">
        <div class="stats-bar__item">
          <div class="stats-bar__num">847,000+</div>
          <div class="stats-bar__label">Career reports delivered</div>
        </div>
        <div class="stats-bar__item">
          <div class="stats-bar__num stats-bar__num--stars">★★★★★</div>
          <div class="stats-bar__label">4.8 on Trustpilot · 2,400+ reviews</div>
        </div>
        <div class="stats-bar__item">
          <div class="stats-bar__num">$23,400</div>
          <div class="stats-bar__label">Avg. salary increase reported</div>
        </div>
        <div class="stats-bar__item">
          <div class="stats-bar__num stats-bar__num--dark">94%</div>
          <div class="stats-bar__label">Coaching satisfaction rate</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.i-stats-bar {
  background: var(--purple-pale);
  padding: 32px 0;
  border-bottom: 1px solid var(--border);

  .stats-bar {
    &__grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      padding: 0 20px;

      @include respond-to(680px) {
        grid-template-columns: repeat(4, 1fr);
        gap: 12px;
        padding: unset;
      }
    }

    &__item {
      background: var(--white);
      border: 1px solid var(--border);
      border-radius: 12px;
      padding: 16px 12px;
      text-align: center;

      @include respond-to(680px) {
        padding: 20px;
      }
    }

    &__num {
      font-size: 1.4rem;
      font-weight: 800;
      color: var(--purple);
      line-height: 1;
      margin-bottom: 6px;
      letter-spacing: -0.02em;

      @include respond-to(680px) {
        font-size: 1.6rem;
      }

      &--stars {
        color: var(--star);
        font-size: 1rem;
        letter-spacing: 2px;
        margin-bottom: 4px;
      }

      &--dark {
        color: var(--text);
      }
    }

    &__label {
      font-size: 0.75rem;
      color: var(--muted);
      line-height: 1.4;
      font-weight: 500;
    }
  }
}
</style>
